import * as React from 'react';
import i18n from 'src/translation/i18n';
import CustomSelect from 'react-select';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import env from 'src/shared/env';
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles
} from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import { commentsRegEx } from 'src/utils/RegexUtils';
import ImageUpload from './ImageUpload/ImageUpload';

class OrderMissingPartPartInfo extends React.Component<IDamagePartInfoProps, any> {
  public render() {
    const theme = createMuiTheme({
      overrides: {
        MuiTooltip: {
          tooltip: {
            fontSize: '15px',
            color: 'black',
            backgroundColor: 'white'
          }
        }
      }
    });
    return (
      <div style={{ marginBottom: '10px'}}>
        <h4>{i18n.t('partClaim.partinfo')}</h4>
        <div className='form-row row '> 
          {this.props.DamagePartInfo.map((part: any, i: any) => (
            <div className={`d-flex`}>
              <div className={`brand-info row form-row mb-0  `} key={i}>
                <div className="form-group col-sm-12  col-md-4 col-lg-3 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="Dpartnumber"
                  >
                    {i18n.t('partClaim.partNumber')}:
                    <span className="required">*</span>
                  </label>
                  <input
                    className={`form-control ${
                      this.props.DamagePartErrorlist[i] &&
                      this.props.DamagePartErrorlist[i].DamagepartNumberError
                        ? 'is-invalid'
                        : this.props.DamageErrormsgshow &&
                          part.DpartNumber === ''
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="part.DpartNumber"
                    type="text"
                    value={part.DpartNumber}
                    onChange={e => this.props.handleDamagePartNumber(e, i)}
                  />
                </div>

                <div className="form-group col-sm-12 col-md-4 col-lg-4 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="orginvoiceNumber"
                  >
                    {i18n.t('partClaim.orginvoiceNumber')}:
                    <span className="required">*</span>
                  </label>
                  <div
                    className={`form-control select-dropdown ${
                      this.props.DamagePartErrorlist[i] &&
                      this.props.DamagePartErrorlist[i]
                        ?.DamageInvoiceNumberError
                        ? 'is-invalid'
                        : this.props.DamageErrormsgshow &&
                          (part.DinvoiceNumber === 0 ||
                            part.DinvoiceNumber.toString() === '')
                        ? 'form-control-error-border'
                        : ''
                    }`}
                  >
                    <CustomSelect
                      options={part.DpartInvoiceList}
                      className="custom-select"
                      onChange={(option: any) => {
                        this.props.handleDamageinvoice(option, i);
                      }}
                      value={part.DInvoiceOption}
                      placeholder="Select Invoice"
                    />
                  </div>

                  <p className="rp-warranty-input-error-internal d-block" style={{maxWidth:'190px'}}>
                    {this.props.DamagePartErrorlist[i] &&
                    this.props.DamagePartErrorlist[i]?.DamageInvoiceNumberError
                      ? `${i18n.t('partClaim.Invoiceerrormsg')}`
                      : ''}
                  </p>
                </div>

                <div className="form-group  col-sm-12  col-md-4 col-lg-2 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="quantity"
                  >
                    {i18n.t('partClaim.qtyOrdered')}:
                    <span className="required">*</span>
                  </label>
                  <input
                    className={`form-control ${
                      this.props.DamagePartErrorlist[i] &&
                      this.props.DamagePartErrorlist[i]?.DamagequantityError
                        ? 'is-invalid'
                        : (this.props.DamageErrormsgshow &&
                            part.Dquantity === 0) ||
                          part.Dquantityshow
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="part.quantity"
                    type="number"
                    pattern="[1-9]*"
                    value={
                      part.Dquantity === 0 ||
                      part.Dquantity < 0 ||
                      Number(part.Dquantity) === 0
                        ? part.Dquantityshow
                        : part.Dquantity
                    }
                    onChange={e => this.props.handleDamagequantity(e, i)}
                    readOnly={
                      part.DinvoiceNumber === 0 ||
                      part.Dquantityshow ||
                      part.Dquantity.toString() === '-'
                        ? true
                        : false
                    }
                    onKeyDown={e =>
                      (e.keyCode === 69 ||
                        e.keyCode === 190 ||
                        e.keyCode === 173 ||
                        e.keyCode === 189 ||
                        e.keyCode === 109 ||
                        e.keyCode === 110 ||
                        e.key === '+') &&
                      e.preventDefault()
                    }
                  />

                  {this.props.DamagePartErrorlist[i] &&
                  this.props.DamagePartErrorlist[i]?.DamagequantityError ? (
                    part.Dquantity === 0 ||
                    part.Dquantity.toString() === '' ||
                    part.Dquantity.toString() === '0' ||
                    part.Dquantity.toString() === '.' ||
                    part.Dquantity.toString().includes('.') ||
                    part.Dquantity.toString() === 'e' ? (
                      <span className="rp-warranty-input-error-internal d-block">
                        {i18n.t('partClaim.atleastqnty')}
                      </span>
                    ) : (
                      <span className="rp-warranty-input-error-internal d-block">
                        {i18n.t('partClaim.quantityerror')} {part.Dtempquantity}{' '}
                      </span>
                    )
                  ) : part.Dquantity > 0 ? (
                    <span className="input-info d-block">
                      {i18n.t('partClaim.Availableqnty')}
                      {part.Dtempquantity}
                    </span>
                  ) : (
                    ''
                  )}
                </div>

                <div className="form-group  col-sm-12  col-md-4 col-lg-2 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="quantityr"
                  >
                    {i18n.t('partClaim.qtyReceived')}:
                    <span className="required">*</span>
                  </label>
                  <input
                    className={`form-control ${
                      this.props.DamagePartErrorlist[i] &&
                      this.props.DamagePartErrorlist[i]?.DamagequantityReceivedError
                        ? 'is-invalid'
                        : (this.props.DamageErrormsgshow &&
                            part.Dquantity === 0) ||
                          part.Dquantityshow
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="part.quantityr"
                    type="number"
                    pattern="[0-9]*"
                    value={part.Dquantityr}
                    onChange={e => this.props.handleDamagequantityReceived(e, i)}
                    readOnly={
                      part.DinvoiceNumber === 0 ||
                      part.DquantityReceivedShow ||
                      part.Dquantity.toString() === '-'
                        ? true
                        : false
                    }
                    onKeyDown={e =>
                      (e.keyCode === 69 ||
                        e.keyCode === 190 ||
                        e.keyCode === 173 ||
                        e.keyCode === 189 ||
                        e.keyCode === 109 ||
                        e.keyCode === 110 ||
                        e.key === '+') &&
                      e.preventDefault()
                    }
                  />

                  {this.props.DamagePartErrorlist[i] &&
                  this.props.DamagePartErrorlist[i]?.DamagequantityReceivedError ? (
                    part.Dquantityr === 0 ||
                    part.Dquantityr.toString() === '' ||
                    part.Dquantityr.toString() === '0' ||
                    part.Dquantityr.toString() === '.' ||
                    part.Dquantityr.toString().includes('.') ||
                    part.Dquantityr.toString() === 'e' ? (
                      <span className="rp-warranty-input-error-internal d-block">
                        {i18n.t('partClaim.atleastQtyReceived')}
                      </span>
                    ) : (
                      <span className="rp-warranty-input-error-internal d-block">
                        {i18n.t('partClaim.receivedQtyValidation')}
                      </span>
                    )
                  )  : (
                    part.Dquantityr > part.Dquantity ?(
                      <span className="rp-warranty-input-error-internal d-block">
                      {i18n.t('partClaim.receivedQtyValidation')}
                    </span>
                    ):
                    ''
                  )}
                </div>




              </div>

              {this.props.DamagePartInfo.length > 1 && (
                <div className={`remove-button pd-delete`}>
                  <div className="rp-delete ">
                    <MuiThemeProvider theme={theme}>
                      <Tooltip
                        title={i18n.t('partClaim.photodelete')}
                        placement="bottom"
                      >
                        <button
                          className="primary-button d-flex"
                          onClick={e => {
                            e.preventDefault();
                            this.props.removePart(i);
                          }}
                        >
                          <DeleteIcon />
                        </button>
                      </Tooltip>
                    </MuiThemeProvider>
                  </div>
                </div>
              )}
            </div>
          ))}

          <div className="mb add-button"  style={{ width: '100%' }}>
            <Button onClick={this.props.addPart} variant="contained">
              {i18n.t('partClaim.addPart')}
            </Button>
          </div> 
        </div>
      </div>
    );
  }
}

export default OrderMissingPartPartInfo;

interface IDamagePartInfoProps {
  DamagePartInfo: any;
  DamagePartErrorlist: any;
  DamageErrormsgshow: boolean;
  handleDamagePartNumber: (event: any, i: any) => void;
  handleDamageinvoice: (event: any, i: any) => void;
  handleDamagequantity: (event: any, i: any) => void;
  handleDamagequantityReceived: (event: any, i: any) => void;            
  addPart: () => void;
  removePart: (i: any) => void;
  // failedimgdelete: () => string;
}
